<template>
  <el-dialog
    v-drag
    title="未识别产品信息"
    :visible.sync="dialogVisible"
    width="1200px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <div class="data">
        <virtual-scroll
          :data="segmentData"
          :item-size="62"
          key-prop="id"
          @change="(renderData) => (dataList = renderData)"
        >
          <el-table
            class="loadmore-table"
            stripe
            :data="dataList"
            height="500px"
          >
            <el-table-column type="selection" align="center" width="55px">
              <template slot-scope="{ row }">
                <el-checkbox
                  v-model="row.isCheck"
                  class="checkBox"
                  @change="handleSelectionChange"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              prop="nameCH"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>中文品名</span>
              </template>
              <template slot-scope="{ row }">
                <el-input v-model="row.nameCH" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="nameEN"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>英文品名</span>
              </template>
              <template slot-scope="{ row }">
                <el-input v-model="row.nameEN" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="hsCode"
              align="center"
              width="220"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>美国税号</span>
              </template>
              <template slot-scope="{ row }">
                <el-input v-model="row.hsCode" :style="{ '--fill-color': row.existsHsCode ? '#f56c6c' : '#606266' }" size="mini" clearable placeholder="请输入内容" @blur="rateBlur(row)">
                  <el-button slot="append" icon="el-icon-search" @click="searchTax(row)"></el-button>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="hsCode"
              align="center"
              width="150"
            >
              <template slot="header">
                <span>税率</span>
              </template>
              <template slot-scope="{ row }">
                <p>基础税率：{{ row.baseRate }}</p>
                <p>加征税率：{{ row.addRate }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="material"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>材质</span>
              </template>
              <template slot-scope="{ row }">
                <el-input v-model="row.material" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="used"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>用途</span>
              </template>
              <template slot-scope="{ row }">
                <el-input v-model="row.used" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="priceMin"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>单价最小值</span>
              </template>
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.priceMin"
                  size="mini"
                  controls-position="right"
                  :min="0.01"
                  :precision="2"
                  :step="1">
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="priceMax"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>单价最大值</span>
              </template>
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.priceMax"
                  size="mini"
                  controls-position="right"
                  :min="row.priceMin || 0.01"
                  :precision="2"
                  :step="1"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="weightMin"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>重量最小值</span>
              </template>
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.weightMin"
                  size="mini"
                  controls-position="right"
                  :min="0.01"
                  :precision="2"
                  :step="1"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="priceMax"
              align="center"
              width="150"
            >
              <template slot="header">
                <span><span style="color:#f56c6c;">*</span>重量最大值</span>
              </template>
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.weightMax"
                  size="mini"
                  controls-position="right"
                  :min="row.weightMin || 0.01"
                  :precision="2"
                  :step="1"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="单价"
              prop="unitPrice"
              align="center"
              width="150"
            >
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.unitPrice"
                  size="mini"
                  controls-position="right"
                  :min="0.01"
                  :precision="2"
                  :step="1">
                </el-input-number>
              </template>
            </el-table-column> -->
            <el-table-column
              label="备注"
              prop="remark"
              align="center"
              width="150"
            >
              <template slot-scope="{ row }">
                <el-input v-model="row.remark" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <div slot="append">
              <InfiniteLoading
                forceUseInfiniteWrapper=".loadmore-table .el-table__body-wrapper"
                @infinite="loadMore"
              >
                <span slot="no-more"></span>
                <span slot="no-result"></span>
              </InfiniteLoading>
            </div>
          </el-table>
        </virtual-scroll>
      </div>
      <p class="selection">已选择 {{ selections.length }} 项</p>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">
        确 定
      </div>
    </span>
    <TaxDialog
      :dialogVisible="dialogVisible2"
      @cancel="dialogVisible2 = false"
      @ok="ok2"
    ></TaxDialog>
  </el-dialog>
</template>

<script>
import VirtualScroll from 'el-table-virtual-scroll'
import InfiniteLoading from 'vue-infinite-loading'
import TaxDialog from '@/components/dialog/TaxDialog.vue'
import { throttle } from '@/utils/common'
import { saveImportTaxProduct, searchUSHts } from '@/api/basic'
// let sourceData
export default {
  components: { VirtualScroll, InfiniteLoading, TaxDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    productData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // tableData: [],
      dataList: [],
      selections: [],
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      rowData: {},
      rowIndex: 0,
      loading: false,
      dialogVisible2: false,
      text: '', // 中文品名 英文品名 税号
      search: '' // 不实时搜索
    }
  },
  computed: {
    virtualData() {
      return this.productData.map((item, i) => {
        return {
          ...item,
          id: i,
          isCheck: false
        }
      })
    },
    segmentData() {
      if (!this.search) {
        return this.virtualData.slice(
         0,
          this.pagerConfig.pageIndex * this.pagerConfig.pageSize
        )
      } else {
        return this.virtualData.filter(item => {
          return item.hsCode.indexOf(this.search) > -1 || item.nameCH.indexOf(this.search) > -1 || item.nameEN.indexOf(this.search) > -1
        }).slice(
         0,
          this.pagerConfig.pageIndex * this.pagerConfig.pageSize
        )
      }
    }
  },
  methods: {
    searchTax(row) {
      this.rowIndex = row.id
      this.rowData = row
      this.dialogVisible2 = true
    },
    loadMore: throttle(async function($state) {
     setTimeout(() => {
      this.pagerConfig = {
        pageIndex: this.pagerConfig.pageIndex + 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.loading = false
      $state && $state.loaded()
     }, 300)
    }, 300),
    cancel() {
      // this.tableData.columns = []
      this.$emit('cancel')
    },
    async ok() {
      if (!this.selections.length) {
        this.$message.error('请勾选未识别的产品数据')
        return
      }
      const flag = this.selections.find(a => {
        return !(a.priceMin && a.priceMax && a.weightMin && a.weightMax && a.used && a.material)
      })
      if (flag) {
        this.$message.error('请完善产品信息')
        return
      }
      try {
        const res = await saveImportTaxProduct(this.selections)
        if (res.success) {
          this.$message.success('保存成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    ok2(rate) {
      const data = {
        ...this.rowData,
        hsCode: rate.hsCode,
        baseRate: rate.baseRate,
        addRate: rate.addRate,
        existsHsCode: true
      }
      this.$set(this.productData, this.rowIndex, data)
      this.dialogVisible2 = false
    },
    handleSelectionChange() {
     this.selections = this.segmentData.filter(item => item.isCheck)
    },
    async rateBlur(row) {
      if (row.hsCode.length !== 10) {
        this.$message.error('税号必须为10位')
        return false
      }
      try {
        const res = await searchUSHts({ code: row.hsCode })
        if (res.success) {
          const data = {
            ...row,
            hsCode: res.data.hsCode,
            baseRate: res.data.baseRate,
            addRate: res.data.addRate,
            existsHsCode: true
          }
          this.$set(this.productData, row.id, data)
          this.dialogVisible2 = false
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: var(--calcWidth);
  height: auto;
  margin: 0 auto;
  text-align: left;
  .step {
    width: 400px;
    height: 40px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #eeeeee;
    margin: 0 auto;
    margin-top: -40px;
    display: flex;
    align-items: center;
    .icon {
      font-size: 14px;
    }
  }
  .active {
    color: rgb(18, 88, 188);
  }
  .step-item {
    width: 193px;
    height: 100%;
    text-align: center;
    line-height: 40px;
  }
  .form {
    width: 100%;
    height: auto;
    margin-top: 40px;
    &:deep(.el-form-item__label) {
      line-height: 30px;
    }
    .el-col:nth-child(2n) {
      display: flex;
      justify-content: flex-end;
    }
  }
  .label {
    width: auto;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .require {
    color: #ff7444;
  }
  .upload {
    width: 320px;
    height: 100px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 160px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgb(18, 88, 188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    .icon {
      font-size: 24px;
      vertical-align: middle;
    }
  }
  .fileList {
    width: 300px;
    height: 40px;
    padding: 12px 10px;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    display: flex;
    .file {
      display: flex;
      flex: 1;
    }
    .opt {
      line-height: 40px;
      font-size: 20px;
      color: #cdcdcd;
      cursor: pointer;
    }
  }
  .file-item {
    text-indent: 10px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
  }
  .fileName {
    color: #666666;
  }
  .fileSize {
    font-size: 12px;
    color: #999999;
  }
  .filter {
    display: flex;
    flex-flow: row-reverse;
    margin-top: 20px;
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 20px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 40px !important;
        /deep/ .el-input__inner {
          height: 40px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
    .code {
      height: 40px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
      display: flex;
      margin-right: 10px;
      span {
        display: inline-block;
        width: 75px;
        margin-right: 10px;
      }
    }
    .filter-btn {
      width: 60px;
      height: 40px;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .switch {
      height: 40px;
      line-height: 40px;
      margin-left: 24px;
      &:deep(.el-switch__label) {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .data {
    width: 100%;
    height: auto;
    margin-top: 20px;
    /deep/ .fTable .el-table {
      border-radius: 4px 4px 4px 4px;
      overflow: hidden;
      .fp-cell {
        border: 0;
      }
      th.el-table__cell > .cell {
        padding-right: 10px;
      }
    }
    &:deep(.el-input__inner) {
      color:  var(--fill-color) !important;
    }
  }
  .selection {
    width: 100%;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 16px;
    margin-top: 10px;
  }
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 20px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
